import { useQuery } from "@tanstack/react-query";
import { getAgent } from "../../api/apiAgents";

const QUERY_KEY = ["agent"];

const useGetAgent = (id) => {
  const {
    data,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: [...QUERY_KEY, id],
    queryFn: () => getAgent(id),
    enabled: !!id,
  });

  return {
    isLoading,
    error: isError ? error : null,
    agent: data?.data || null,
  };
};

export default useGetAgent;
